import { keyBy } from './core';

export function getProp(payload, prop, validate) {
  return {
    name: prop,
    value: payload[prop],
    error: validate(prop, payload[prop]),
    touched: false,
  };
}

export function formatProp(payload = {}, prop = '', validate) {
  if (Array.isArray(payload[prop])) {
    // eslint-disable-next-line no-use-before-define
    return formatArray(payload, prop, validate);
  }

  if (typeof payload[prop] === 'object' && payload[prop] != null) {
    // eslint-disable-next-line no-use-before-define
    return formatObject(payload, prop, validate);
  }

  if (prop) {
    return getProp(payload, prop, validate);
  }
}

function formatArray(payload, prop, validate) {
  return payload[prop].map((_item, index) => formatProp(payload[prop], index, validate));
}

function formatObject(payload, prop, validate) {
  const propsArray = Object.keys(payload[prop]);

  return keyBy(
    propsArray,
    name => name,
    name => formatProp(payload[prop], name, validate),
  );
}

export function formatPayload(payload, validate) {
  const propsArray = Object.keys(payload);

  return keyBy(
    propsArray,
    name => name,
    name => getProp(payload, name, validate),
  );
}
